var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrendSameWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none",
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffffb3",
    d: "M7.539 1.478c.12-.15.36-.15.51 0L14.32 7.75c.15.15.15.36 0 .51l-6.272 6.272c-.15.15-.39.15-.51 0l-.6-.57c-.15-.15-.15-.39 0-.51l4.65-4.682H1.357c-.21 0-.36-.15-.36-.36v-.84c0-.18.15-.36.36-.36H11.59L6.938 2.557c-.15-.12-.15-.36 0-.51l.6-.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrendSameWhite);
export default __webpack_public_path__ + "static/media/icon-trend-same-white.6b76615ffbde4c474d3663fdcce4fcf4.svg";
export { ForwardRef as ReactComponent };